import { gql } from "@apollo/client";

import AssessmentQuestionFragment from "@apps/assessments/graphql/assessment-question-fragment";

export default gql`
  ${AssessmentQuestionFragment}
  query getAssessmentGroupForSidebar($assessmentGroupId: Int!) {
    assessmentGroup(assessmentGroupId: $assessmentGroupId) {
      id
      title
      created
      archived
      isOnlySelfAssessment
      hasNpsQuestions
      questionCount
      assessmentType
      creator {
        id
        name
      }
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      sections {
        edges {
          node {
            id
            title
            description
            questions {
              edges {
                node {
                  id
                  question {
                    ...AssessmentQuestionFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
